import { Component, input, output } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { iconoirRefresh } from '@ng-icons/iconoir';

@Component({
  selector: 'app-error-state',
  templateUrl: './error-state.component.html',
  styleUrls: ['./error-state.component.scss'],
  imports: [NgIcon],
  providers: [
    provideIcons({
      iconoirRefresh,
    }),
  ],
})
export class ErrorStateComponent {
  public message = input<string>('Failed to load data');
  public retryButtonText = input<string>('Retry');
  public iconSize = input<number>(24);
  
  public onRetry = output<void>();

  /**
   * @description Emits retry event
   */
  handleRetry = (): void => {
    this.onRetry.emit();
  };
}
